import React from "react"

import "./leftpanelbtn.scss"

/**
 * Button on left panel. This button toggle menu for work with text and images
 * @component
 * @param  {object} props
 * @param  {function} props.handler - handler button onclick function
 * @param  {string} props.value - value button onclick value
 * @param  {string} props.icon - icon url for button icon
 * @param  {string} props.title - title button title
 * @param  {boolean} props.active - active button state
 *
 * @example
 * const handler = () => {}
 * const value = 'string'
 * const icon = './src'
 * const title = 'title'
 * const active = false
 *
 * return (
 *  <LeftPanelBtn
 *    handler={handler}
 *    value={value}
 *    icon={icon}
 *    title={title}
 *    active={active}
 *  />
 * )
 */

//  /**
//  * Select font
//  * @param {object} e - element
//  * @param {object} e.target - target element
//  */

const LeftPanelBtn = ({handler, value, icon, title, active}) => {
  return (
    <button
      onClick={handler}
      className={"leftPanelBtnContainer"+(active?" leftPanelBtnActive":"")}
      disabled={active}
      data-value={value}
    >
      <img src={icon} alt={title} />
      <span>{title}</span>
    </button>
  )
}

export default LeftPanelBtn
